// extracted by mini-css-extract-plugin
export default {"Angledblock":"angledblock_Angledblock__KK2E0","BeforeShape":"angledblock_BeforeShape__pc6sD","MainBlock":"angledblock_MainBlock__M+RVj","AfterShape":"angledblock_AfterShape__zu2T1"};